import { connect } from 'react-redux';
import View from '../../../Navigation/Back/BackView';
import {
  currentClientIdOrDefaultSelector,
  isBusySelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateValidation, updateSupportData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { buildMutation } from '../../../AdvWorkflow/AdvWorkflowHelpers';
import { setDraftAccount, setViewId } from '../AccountsManualStepActions';
import { BASE_ACCOUNT } from '../../FinancialAccountsWorkflowConstants';
import { OVERVIEW } from '../AccountsManualStepViews';

const mapStateToProps = (state, ownProps) => ({
  backText: 'Cancel',
  clientId: currentClientIdOrDefaultSelector(state, ownProps),
  isBusy: isBusySelector(state, ownProps),
});
const mapDispatchToProps = dispatch => ({
  onBack: (validationId, clientId, workflowId) => () => {
    if (validationId) {
      dispatch(updateValidation(buildMutation(validationId, []), workflowId, clientId));
    }
    dispatch(updateSupportData({}, workflowId));
    dispatch(setDraftAccount(BASE_ACCOUNT, workflowId));
    dispatch(setViewId(OVERVIEW, workflowId));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(View);
